import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import { LoadingOverlay } from '../../../common/loading_overlay'

import { getDriverHistoryData, getDriverHistoryFetching } from '../selectors'
import * as driversActionCreators from '../actionCreators'

import DriversHistoryListRow from './DriversHistoryListRow'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS_HISTORY } from '../permissions'

class DriversHistoryList extends Component {
    handleExport = e => {
        e && e.preventDefault()
        this.props.actions.exportDriverHistory(this.props.driver.id)
    }

    componentDidMount() {
        if (this.props.driver) {
            this.props.actions.fetchDriverHistory(this.props.driver.id)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.driver && JSON.stringify(nextProps.driver) !== JSON.stringify(this.props.driver)) {
            this.props.actions.fetchDriverHistory(nextProps.driver.id)
        }
    }

    render() {
        const driver = this.props.driver
        const data = this.props.data

        return (
            <PermissionsCheck hasAny={Object.values(PERMS_HISTORY)} noPermissionsTab>
                <LoadingOverlay active={this.props.fetching}>
                    {data && data.length > 0 ? (
                        <React.Fragment>
                            {this.props.showDriverName && <h4>{driver && driver.getFullName()}</h4>}

                            <div className="btns-list">
                                <PermissionsCheck has={[PERMS_HISTORY.EXPORT]}>
                                    <button className="btn btn-primary btn-addon" onClick={this.handleExport}>
                                        <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                    </button>
                                </PermissionsCheck>
                            </div>

                            <div className="table-container table-container-no-pagination">
                                <table className="table table-striped table-hover table-fixed-header">
                                    <thead>
                                        <tr>
                                            <th className="w-120">
                                                <FormattedMessage id="fields.from" />
                                            </th>
                                            <th className="w-120">
                                                <FormattedMessage id="fields.to" />
                                            </th>
                                            <th className="w-140">
                                                <FormattedMessage id="fields.vehicle" />
                                            </th>
                                            <th className="w-max">
                                                <FormattedMessage id="fields.trailer" />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data &&
                                            data.map((item, index) => (
                                                // eslint-disable-next-line react/no-array-index-key
                                                <DriversHistoryListRow key={`row-${index}`} item={item} nextItem={data[index + 1]} />
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {this.props.showDriverName && (
                                <div className="pull-left wp-100">
                                    <h4>{driver && driver.getFullName()}</h4>
                                </div>
                            )}
                            <div className="alert alert-danger pull-left wp-100">
                                <FormattedMessage id="fields.noItemsFound" />
                            </div>
                        </React.Fragment>
                    )}
                </LoadingOverlay>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state) {
    return {
        data: getDriverHistoryData(state),
        fetching: getDriverHistoryFetching(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...driversActionCreators,
                },
                dispatch
            ),
        },
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(DriversHistoryList)
)
